import { Contacts } from './Contacts';

export const contactsRoutes = [{ index: true, element: <Contacts /> }];
